import { useEffect } from 'react';

/**
 * Dynamically injects a <script> tag.
 * @param {string} src          - external script URL (optional if you only need inline)
 * @param {string} [id]         - unique id so we don't inject twice
 * @param {string} [innerHTML]  - inline code (optional)
 * @param {boolean} [async=true]
 * @param {boolean} [enabled=true] - gate the whole injection
 * @param {Function} [onLoad]   - callback function on script load
 */
export function useScript({
  src,
  id,
  innerHTML,
  async = true,
  enabled = true,
  onLoad,
}) {
  useEffect(() => {
    if (!enabled) return;

    // Already present?
    if (id && document.getElementById(id)) return;

    const script = document.createElement('script');
    if (id) script.id = id;
    if (src) script.src = src;
    if (innerHTML) script.innerHTML = innerHTML;
    script.async = async;

    if (onLoad) script.onload = onLoad;

    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      if (id) {
        const el = document.getElementById(id);
        if (el) el.remove();
      }
    };
  }, [src, id, innerHTML, async, enabled, onLoad]);
}

export default useScript;
